export default () => [
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'costTypeValue',
    align: 'left',
    minWidth: 100,
    title: '费用类型值',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'costItemValue',
    align: 'left',
    minWidth: 100,
    title: '费用值',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'costItemRemarks',
    align: 'left',
    minWidth: 150,
    title: '备注说明',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    align: 'left',
    width: 170,
    title: '修改时间',
    sortable: true,
  },
]
